import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { router } from './rotas/raiz.tsx'
import './estilo.css'

const raiz = document.getElementById('raiz')
if (raiz === null) throw new Error('elemento #raiz não encontrado no index.html')

createRoot(raiz).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
